export default __webpack_public_path__ + "6a9537b4381101ba376b95d9c0909c6c.jpg";